import CSSMotion from './CSSMotion';
import CSSMotionList from './CSSMotionList';
export { CSSMotionList };
export default CSSMotion;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-motion/es/index.js
// module id = 115
// module chunks = 0